<template>
  <b-modal
      ref="show-withdraw-transaction-modal"
      :title="$t('withdraw-transaction.details.label.modal')"
      :cancel-title="$t('btn.close')"
      ok-only
      size="lg"
  >
    <div class="question-details">
      <h4>{{ $t('withdraw-transaction.details.title.basic_data') }}</h4>
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <div v-if="!userData" class="d-flex justify-content-center spinner-border text-primary" role="status"></div>
          <table class="table" v-if="userData">
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.user_bank_account') }}</th>
              <td>{{ transactionDetails.bankAccountPrefix }}{{ transactionDetails.bankAccountNumber }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.transfer_title') }}</th>
              <td>{{ transactionDetails.id | shortId }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.transfer_amount') }}</th>
              <td>{{ transactionDetails.amount }} {{ transactionDetails.currency }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.user_email') }}</th>
              <td>{{ transactionDetails.userEmail }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.first_name') }}</th>
              <td>{{ userData.firstName }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.last_name') }}</th>
              <td>{{ userData.lastName }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.user_nick_name') }}</th>
              <td>{{ transactionDetails.userNickName }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{$t('withdraw-transaction.details.label.country')}}</td>
              <td>{{ $t($store.getters["root/countryLabel"](userData.country)) }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.city') }}</th>
              <td>{{ userData.city }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.post_code') }}</th>
              <td>{{ userData.postCode }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.street') }}</th>
              <td>{{ userData.street }}</td>
            </tr>
            <tr>
              <th>{{ $t('withdraw-transaction.details.label.phone') }}</th>
              <td>{{ userData.phonePrefix }} {{ userData.phone }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      userData: null
    }
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    openModal() {
      this.$refs['show-withdraw-transaction-modal'].show()
    },
    getUserData() {
      axios.get(`/api/client-security/player/${this.transactionDetails.userId}`)
        .then(resp => {
          this.userData = resp.data;
        });
    }
  }
}
</script>
